import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDotsArrowRegularRightIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M28.4 16.8c.5-.4.5-1.2 0-1.6l-6.8-6.9c-.4-.4-1.2-.4-1.6 0q-.7 1 0 1.7l4.7 4.8H10.8a1.2 1.2 0 1 0 0 2.4h13.9L20 21.9q-.7 1 0 1.7.8.8 1.6 0zM4.8 25.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2m1.6-7a1.6 1.6 0 1 0-3.2 0 1.6 1.6 0 0 0 3.2 0M4.8 15a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M6.4 8a1.6 1.6 0 1 0-3.2 0 1.6 1.6 0 0 0 3.2 0" })
});
export default SvgDotsArrowRegularRightIcon;
